<template>
  <!-- フッター-->
  <footer :class="{ footer: hasSidebar, 'footer-secondary': !hasSidebar }">
    <confirm-dialog
      name="logout"
      :is-shown="logoutDialogIsShown"
      title="ログアウト"
      @closed="logoutDialogIsShown = false"
      @default-clicked="onDefaultClicked"
      @cancel-clicked="logoutDialogIsShown = false">
      <template #body>
        ログアウトします。<br />
        よろしいですか？
      </template>
    </confirm-dialog>
    <div :class="{ 'footer-left': hasSidebar, 'footer-secondary-left': !hasSidebar }">
      <ul class="footer-nav">
        <li
          v-if="isLoggedIn"
          class="footer-nav__node">
          <a
            class="footer-nav__link"
            href=""
            @click.prevent="onLogoutClicked">
            ログアウト
          </a>
        </li>
        <li
          v-if="$store.state.auth.company.account_type < 2"
          class="footer-nav__node">
          <router-link
            :to="{ name: 'company' }"
            class="footer-nav__link">
            運営会社
          </router-link>
        </li>
        <li
          v-if="$store.state.auth.company.account_type < 2"
          class="footer-nav__node">
          <router-link
            :to="{ name: 'privacy' }"
            class="footer-nav__link">
            個人情報保護方針
          </router-link>
        </li>
        <li
          v-if="isBtoC"
          class="footer-nav__node">
          <router-link
            :to="{ name: 'scta' }"
            class="footer-nav__link">
            特定商取引法に<br class="sp">基づく表記
          </router-link>
        </li>
      </ul>
    </div>
    <div class="footer-right">
      <div
        v-if="isBtoB"
        class="footer-wrap">
        <div
          v-if="appName === 'Zu-MAP'"
          class="footer-wrap__logo">
          <a
            href="http://zula.jp/"
            target="_blank">
            <img
              src="/img/common/logo.png"
              alt="Zu-MAP">
          </a>
        </div>
        <p
          v-if="appName === 'Zu-MAP'"
          class="footer-wrap__copyright">
          &copy;ZULA All rights reserved.
        </p>
        <p
          v-else
          class="footer-wrap__copyright">
          &copy;{{ appName }} All rights reserved.
        </p>
      </div>
      <div
        v-else
        class="footer-wrap">
        <div class="footer-wrap__logo">
          <a
            href="https://narasu.jp/"
            target="_blank">
            <img
              src="/img/narasu/logo.png"
              alt="narasu">
          </a>
        </div>
        <p class="footer-wrap__copyright">
          &copy;narasu All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmDialog from '../../components/ConfirmDialog'

export default {
  name: 'FooterContent',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      logoutDialogIsShown: false,
      showLogout: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters(['isSidebarHidden']),
    hasSidebar() {
      return this.isLoggedIn && !this.isSidebarHidden
    },
  },
  methods: {
    onLogoutClicked() {
      this.logoutDialogIsShown = true
    },
    async onDefaultClicked() {
      this.logoutDialogIsShown = false
      try {
        await this.$store.dispatch('auth/logout')
        await this.$router.push('/client/login')
      } catch (err) {
        await this.$router.push('/client')
      }
    },
  },
}
</script>

<style scoped>

</style>
